import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

let threadTid;
let threadValue;

const fetchUpdateThreadCount = async () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateTestSuiteThreadCount&companyid=${user.companyid}&tsuid=${threadTid}&value=${threadValue}`,
  );

  return response.data;
};

const useUpdateTestSuiteThreadCount = () => {
  const query = useQuery({
    queryKey: ["updateTestSuiteThreadCount"],
    queryFn: () => {
      return fetchUpdateThreadCount(threadTid, threadValue);
    },
    enabled: false,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });

  const refetchWithParams = (id, value) => {
    threadValue = value;
    threadTid = id;
    query.refetch();
  };

  return {
    ...query,
    refetchWithParams,
  };
};

export default useUpdateTestSuiteThreadCount;
